import { MutationTree } from "vuex";
import { Survey, SurveyMutations, SurveyState } from "./interface";
import { SurveyMutationsTypes } from "./types";

export const mutations: MutationTree<SurveyState> & SurveyMutations = {
  [SurveyMutationsTypes.SET_SURVEY](state: SurveyState, payload: Array<Survey>): void {
    state.SurveyById = {};
    state.SurveyAllId = [];

    payload.forEach((survey) => {
      state.SurveyById[survey._id] = survey;
      state.SurveyAllId.push(survey._id);
    });
  },
  [SurveyMutationsTypes.CREATE_SURVEY](state: SurveyState, payload: Survey): void {
    state.SurveyById[payload._id] = payload;
    state.SurveyAllId.unshift(payload._id);
  },
  [SurveyMutationsTypes.UPDATE_SURVEY](state: SurveyState, payload: Survey): void {
    state.SurveyAllId.splice(state.SurveyAllId.lastIndexOf(payload._id), 1);
    state.SurveyById[payload._id] = payload;
    state.SurveyAllId.unshift(payload._id);
  }
};
